export const GlassCard = {
  flow: 'y',
  theme: 'glass',
  padding: 'B',
  borderRadius: 'Z',
  border: '1px solid white.08',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  ':hover': {
    borderColor: 'white.15',
  },
}
